module.exports = __webpack_public_path__ + "img/gabriel-garcia-marengo-kOqBCFsGTs8-unsplash.9eb0d127.jpg";